var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyAccountCreationOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6265 14.8521L23.2339 12.4902L17.4433 18.2083L14.8233 15.62L12.4307 17.9818L16.9721 22.4649L16.9884 22.4508L17.4596 22.914L25.6265 14.8521Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9087 46.9975H3.07575C1.93429 46.9975 1 46.0752 1 44.9485V3.04906C1 1.92228 1.93429 1 3.07575 1H29.372L36.9845 9.19823V44.9485C36.9845 46.0752 36.0502 46.9975 34.9087 46.9975Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9121 4.61914V7.80701C27.9121 8.93379 28.8464 9.85607 29.9879 9.85607H36.1907",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74512 29.4463H30.2392",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74512 33.9932H30.2392",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74512 38.6592H30.2392",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAccountCreationOverview);
export default __webpack_public_path__ + "static/media/company-account-creation-overview.0ae34ebcaeb895f26ff5cf22ce4270a0.svg";
export { ForwardRef as ReactComponent };